import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'safe',
  standalone: false
})
export class SafePipe implements PipeTransform {

  constructor(protected sanitizer: DomSanitizer) {}

  public transform(value: any, type: string): SafeHtml {
    if (type === 'html') {
      const clean = DOMPurify.sanitize(value ?? '', { USE_PROFILES: { html: true } });
      return this.sanitizer.bypassSecurityTrustHtml(clean);
    }
    throw new Error();
  }
}
